import type {NearExpiryReportItem, ReportScreenKind} from './reports.models';

export type ReportScreenConfig = {
  kind: ReportScreenKind;
  expirationStatus: 'ExpiringSoon' | 'Expired';
  route: string;
  titleKey: string;
  subtitleKey: string;
  emptyKey: string;
  statusLabelKey: string;
};

export function isReportScreenKind(value: string | null | undefined): value is ReportScreenKind {
  return value === 'expiring' || value === 'expired';
}

export function filterReportItems(items: readonly NearExpiryReportItem[], screenKind: ReportScreenKind): NearExpiryReportItem[] {
  const expectedStatus = screenKind === 'expiring' ? 'ExpiringSoon' : 'Expired';
  return items.filter((item) => item.expirationStatus === expectedStatus);
}

export function buildReportPath(item: NearExpiryReportItem): string {
  if (item.path.length > 0) {
    return item.path.map((segment) => segment.name).join('/');
  }

  return item.locationLabel ?? item.name;
}
